import yaml from 'js-yaml';
import { HttpHeader, MediaType } from '../http-service-constants.js';
function createBlobBodyMapper() {
    const ACCEPTED_TYPES = [
        MediaType.APPLICATION_OCTET_STREAM,
        MediaType.IMAGE_BMP,
        MediaType.IMAGE_GIF,
        MediaType.IMAGE_JPEG,
        MediaType.IMAGE_JPG,
        MediaType.IMAGE_PNG,
    ];
    const accepts = (contentType) => {
        return ACCEPTED_TYPES.some(type => contentType.includes(type));
    };
    const map = (response) => {
        return response.blob();
    };
    return { accepts, map };
}
function createPDFBlobBodyMapper() {
    const accepts = (contentType) => {
        return contentType.includes(MediaType.APPLICATION_PDF);
    };
    const map = (response) => {
        return response.arrayBuffer().then(buffer => new Blob([buffer], { type: MediaType.APPLICATION_PDF }));
    };
    return { accepts, map };
}
function createJsonBodyMapper() {
    const accepts = (contentType) => {
        return contentType.includes(MediaType.APPLICATION_JSON);
    };
    const map = (response) => {
        return response.json();
    };
    return { accepts, map };
}
function createTextBodyMapper() {
    const ACCEPTED_TYPES = [
        MediaType.TEXT_CSS,
        MediaType.TEXT_HTML,
        MediaType.TEXT_PLAIN,
    ];
    const accepts = (contentType) => {
        return ACCEPTED_TYPES.some(type => contentType.includes(type));
    };
    const map = (response) => {
        return response.text();
    };
    return { accepts, map };
}
function createYamlBodyMapper() {
    const accepts = (contentType) => {
        return contentType.includes(MediaType.APPLICATION_YAML);
    };
    const map = async (response) => {
        const raw = await response.text();
        return yaml.load(raw);
    };
    return { accepts, map };
}
const BODY_MAPPERS = [
    createBlobBodyMapper(),
    createPDFBlobBodyMapper(),
    createJsonBodyMapper(),
    createTextBodyMapper(),
    createYamlBodyMapper(),
];
function mapResponseBody(response) {
    const responseContentType = response.headers.get(HttpHeader.CONTENT_TYPE) ?? MediaType.APPLICATION_JSON;
    const mapper = BODY_MAPPERS.find(mapper => mapper.accepts(responseContentType));
    if (!mapper) {
        throw new Error(`[HttpService]: No body mapper found for ContentType ${responseContentType}.`);
    }
    return mapper.map(response);
}
export { mapResponseBody, };
//# sourceMappingURL=http-service-response-mappers.js.map